import { Link } from 'gatsby';
import React from 'react'

export default function CallPhoneLink({ phoneNumber, children }) {
    const formattedPhoneNumber = phoneNumber?.replace(/[^0-9+]/g, '');
  return (
    <div>
        <Link to={`tel:${formattedPhoneNumber}`} className="call-phone-link">
        {children || phoneNumber}
        </Link>
    </div>
  )
}
